'use client';

import { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import Header from './Header';
import Hero from './Hero';
import Features from './Features';
import SupportedBy from './SupportedBy';
import Pricing from './Pricing';
import ImpactMetrics from './Metrics';
import Differentiators from './Differentiators';
import TransformProcurement from './TransformProcurement';
import Footer from './Footer';
import HubSpotChat from './HubSpotChat';
import RfpMatchingSection from './RfpMatchingSection';

gsap.registerPlugin(ScrollTrigger);

export default function Home() {
  const sectionsRef = useRef([]);

  const addToRefs = (el) => {
    if (el && !sectionsRef.current.includes(el)) {
      sectionsRef.current.push(el);
    }
  };

  useEffect(() => {
    if (typeof window === 'undefined') return;

    sectionsRef.current.forEach((section) => {
      // Skip ImpactMetrics since it handles its own animation
      if (
        section &&
        !section.classList.contains(
          'impact-metrics-section' || !section.classList.contains('footer'),
        )
      ) {
        gsap.fromTo(
          section,
          { opacity: 0, y: 50 },
          {
            opacity: 1,
            y: 0,
            duration: 1,
            ease: 'power2.out',
            scrollTrigger: {
              trigger: section,
              start: 'top 80%',
              toggleActions: 'play none none reverse',
            },
          },
        );
      }
    });
  }, []);

  return (
    <>
      <div>
        <Header />
      </div>
      <main className="min-h-screen bg-white">
        <div ref={addToRefs}>
          <Hero />
        </div>
        <div ref={addToRefs}>
          <SupportedBy />
        </div>
        <div>
          <Features />
        </div>
        {/* <div ref={addToRefs} id="pricing"><Pricing /></div> */}

        <div className="impact-metrics-section">
          <ImpactMetrics />
        </div>
        <div ref={addToRefs} id='rfp-matching'>
          <RfpMatchingSection />
        </div>

        <div ref={addToRefs}>
          <Differentiators />
        </div>
        <div ref={addToRefs} id="pricing">
          <Pricing />
        </div>
        <div ref={addToRefs}>
          <TransformProcurement />
        </div>
        <div className="footer">
          <Footer />
        </div>
        <HubSpotChat />
      </main>
    </>
  );
}